import { baseRoute } from '../../constants/routes';

export const QUIZ_ROUTE = baseRoute + '/quizzes';
export const QUIZ_INTRO_SETTINGS_ROUTE = baseRoute + '/intro-settings';
export const QUIZ_REGISTRATION_SETTINGS_ROUTE = baseRoute + '/registration-settings';
export const QUIZ_RESULT_SETTINGS_ROUTE = baseRoute + '/result-settings';
export const FILTER_QUIZZES_ROUTE = baseRoute + '/quizzes/filters';
export const CHANGE_STATUS_ROUTE = baseRoute + '/quizzes/change-status';
export const QUIZ_DUPLICATE_ROUTE = baseRoute + '/quizzes/duplicate';

export const CREATE_QUIZ = 'CREATE_QUIZ';
export const CREATE_QUIZ_SUCCESS = 'CREATE_QUIZ_SUCCESS';
export const CLEAR_CREATED_QUIZ = 'CLEAR_CREATED_QUIZ';

export const GET_QUIZ = 'GET_QUIZ';
export const GET_QUIZ_SUCCESS = 'GET_QUIZ_SUCCESS';
export const ERASE_QUIZ_SUCCESS = 'ERASE_QUIZ_SUCCESS';

export const GET_ALL_QUIZZES = 'GET_ALL_QUIZZES';
export const GET_ALL_QUIZZES_SUCCESS = 'GET_ALL_QUIZZES_SUCCESS';

export const UPDATE_QUIZ = 'UPDATE_QUIZ';
export const UPDATE_QUIZ_SUCCESS = 'UPDATE_QUIZ_SUCCESS';

export const DELETE_QUIZ = 'DELETE_QUIZ';
export const DELETE_QUIZ_SUCCESS = 'DELETE_QUIZ_SUCCESS';

export const CLEAR_QUIZZES = 'CLEAR_QUIZZES';

export const UPDATE_QUIZ_INTRO = 'UPDATE_QUIZ_INTRO';
export const UPDATE_QUIZ_INTRO_SUCCESS = 'UPDATE_QUIZ_INTRO_SUCCESS';

export const UPDATE_QUIZ_INTRO_SETTINGS = 'UPDATE_QUIZ_INTRO_SETTINGS';
export const UPDATE_QUIZ_INTRO_SETTINGS_SUCCESS = 'UPDATE_QUIZ_INTRO_SETTINGS_SUCCESS';

export const UPDATE_QUIZ_REGISTRATION = 'UPDATE_QUIZ_REGISTRATION';
export const UPDATE_QUIZ_REGISTRATION_SUCCESS = 'UPDATE_QUIZ_REGISTRATION_SUCCESS';

export const UPDATE_QUIZ_REGISTRATION_SETTINGS = 'UPDATE_QUIZ_REGISTRATION_SETTINGS';
export const UPDATE_QUIZ_REGISTRATION_SETTINGS_SUCCESS = 'UPDATE_QUIZ_REGISTRATION_SETTINGS_SUCCESS';

export const UPDATE_QUIZ_RESULT = 'UPDATE_QUIZ_RESULT';
export const UPDATE_QUIZ_RESULT_SUCCESS = 'UPDATE_QUIZ_RESULT_SUCCESS';

export const UPDATE_QUESTION_DRAG_DROP = 'DROP';
export const UPDATE_QUESTION_DRAG_DROP_SUCCESS = 'UPDATE_QUESTION_DRAG_DROP_SUCCESS';

export const UPDATE_QUIZ_RESULT_SETTINGS = 'UPDATE_QUIZ_RESULT_SETTINGS';
export const UPDATE_QUIZ_RESULT_SETTINGS_SUCCESS = 'UPDATE_QUIZ_RESULT_SETTINGS_SUCCESS';

export const FILTER_QUIZZES = 'FILTER_QUIZZES';
export const FILTER_QUIZZES_SUCCESS = 'FILTER_QUIZZES_SUCCESS';

export const CHANGE_STATUS = 'CHANGE_STATUS';
export const CHANGE_STATUS_SUCCESS = 'CHANGE_STATUS_SUCCESS';

export const GET_TENANT_STATISTIC = 'GET_TENANT_STATISTIC';
export const GET_TENANT_STATISTIC_SUCCESS = 'GET_TENANT_STATISTIC_SUCCESS';

export const DUPLICATE_QUIZ = 'DUPLICATE_QUIZ';
export const DUPLICATE_QUIZ_SUCCESS = 'DUPLICATE_QUIZ_SUCCESS';


